import { useEffect, useState } from "react";
import { Trophy, Medal, Crown } from "lucide-react";
import { api, brl } from "@/lib/api";

const MEDAL = ["#F5C518", "#B8B8B8", "#CD7F32"];

/** Ranking mensal de indicadores da cidade (visão do usuário). */
export default function RankingCard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/referral/ranking").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return null;

  const prizes = [d.prizes.prize_top1, d.prizes.prize_top2, d.prizes.prize_top3];
  const monthLabel = new Date(`${d.month}-01T12:00:00`).toLocaleDateString("pt-BR", { month: "long", year: "numeric" });

  return (
    <div className="mt-6" data-testid="referral-ranking">
      <h2 className="font-display font-bold text-base flex items-center gap-2">
        <Trophy size={17} className="text-mage-yellow" /> Ranking do mês — {monthLabel}
      </h2>
      <p className="text-[11px] text-gray-500">
        Quem mais ganha comissão na cidade leva o prêmio: {prizes.map((p) => brl(p)).join(" · ")}
      </p>

      {d.me && (
        <div className="mt-3 rounded-2xl bg-gf-black text-white p-4 flex items-center gap-3" data-testid="my-ranking-position">
          <Crown size={20} className="text-mage-yellow" />
          <div className="flex-1">
            <p className="font-display font-extrabold">Você está em {d.me.position}º lugar</p>
            <p className="text-[11px] text-white/75">
              {brl(d.me.earned)} em comissões · {d.me.orders} pedidos da sua rede · {d.total_participants} participantes
            </p>
          </div>
        </div>
      )}

      <div className="grid gap-2 mt-3" data-testid="ranking-list">
        {d.ranking.map((r) => (
          <div key={r.user_id} className="rounded-2xl border border-gray-200 p-3 flex items-center gap-3"
            style={r.position <= 3 ? { borderColor: MEDAL[r.position - 1] } : undefined}
            data-testid={`ranking-row-${r.position}`}>
            <span className="w-8 h-8 rounded-full flex items-center justify-center font-display font-extrabold text-xs text-white shrink-0"
              style={{ background: r.position <= 3 ? MEDAL[r.position - 1] : "#141414" }}>
              {r.position}
            </span>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-sm truncate">{r.name}</p>
              <p className="text-[11px] text-gray-500">
                {r.indicated} indicados · {r.orders} pedidos
                {r.position <= 3 && <b className="text-mage-green"> · prêmio {brl(prizes[r.position - 1])}</b>}
              </p>
            </div>
            <p className="font-display font-extrabold text-gf-orange shrink-0">{brl(r.earned)}</p>
          </div>
        ))}
        {d.ranking.length === 0 && (
          <p className="text-xs text-gray-500">
            Ninguém pontuou este mês ainda — indique agora e assuma o 1º lugar.
          </p>
        )}
      </div>

      {d.paid && (
        <p className="text-[11px] text-mage-green font-semibold mt-2" data-testid="ranking-paid">
          <Medal size={12} className="inline" /> Prêmios deste mês já pagos ({brl(d.paid_total)}).
        </p>
      )}
    </div>
  );
}
